<script lang="ts" generics="T, R">
	import type { CarouselTypeOption, FlickityOptions as Options } from "$lib/serv/vendor-integration/splide";
	import type { Cache } from "$lib/serv/core/cache";
	import type { Snippet } from "svelte";


	// @ts-ignore: Declare module manually for Flickity
	import type * as Flickity from "flickity";

	import CarouselV3 from "./CarouselV3.svelte";

	// import '../../../scss/component/carousel.scss';

	export let cache: Cache<T> = { loading: true } as Cache<T>;
	export let type: CarouselTypeOption;
	export let key: (payload: T) => R[] = (payload) => Array.isArray(payload) ? payload as R[] : [] as R[];
	/**
	 * For dynamic carousels (e.g. grocery LI saved items swimlane), we use this in a keyed each
	 * block to help Svelte manage carousel item removals correctly
	 * */
	export let uniqueKey: ((item: R) => string|number) | undefined = undefined;
	export let options: Options = {};
	export let id = '';

	interface $$Slots {
		title: {};
		default: {
			item: R;
			index: number;
		};
  }
</script>
<!-- 
<script lang="ts" generics="T, R">
	

	// import '../../../scss/component/carousel.scss';

	interface Options extends Flickity.Options { fade?: boolean }

	type Props = {
		cache: Cache<T>;
		type?: CarouselTypeOption;
		key?: (payload: T) => R[];
		uniqueKey?: ((item: R) => string|number) | undefined;
		options?: Options;
		resize?: () => void;
		id?: string;
		title?: Snippet;
		children: Snippet<[{
			item: R;
			index: number;
		}]>;
	}

	let {
		cache,
		type = 'aisle',
		key = (payload: T) => Array.isArray(payload) ? payload as R[] : Array(9) as R[],
		uniqueKey,
		options = {},
		resize = $bindable(() => {}),
		id,
		title,
		children
	}: Props = $props();

	
</script> -->

<CarouselV3 {cache} {type} {key} {uniqueKey} {id}>
	{#snippet title()}
		<slot name='title'></slot>
	{/snippet}
	{#snippet children({ item, index })}
		<slot {item} {index}></slot>
	{/snippet}
</CarouselV3>
